import { clsx } from 'clsx';
import { Alert } from '@material-ui/lab';

import { OrderDetailWhim } from '../order-detail-whim';
import { OrderProductsByCorridor } from '../order-products-by-corridor';
import { OrderDetailDisclaimer } from 'components/order-management/shared';
import { ForceOrderInvoicePrinting } from 'features/print-management/order-invoice-printing';
import { ReactComponent as BagOutlineIcon } from 'assets/images/icons/BagOutlineIcon.svg';

import { useOrderDetailDialogProductsSection } from './useOrderDetailDialogProductsSection';

import makeClasses from './OrderDetailDialogProductsSection.styles';

function OrderDetailDialogProductsSection({
  orderDetailDescription,
  orderManagement,
  hasOrderManagement,
  classes = {},
}) {
  const {
    lang,
    orderId,
    productsByCorridor,
    whims,
    isBeingManaged,
    isAuditable,
  } = useOrderDetailDialogProductsSection();

  const _classes = makeClasses();

  return (
    <div className={clsx(_classes.root, classes?.root)}>
      <div
        className={clsx(
          _classes.productsByCorridorContainer,
          classes?.productsByCorridorContainer,
        )}
      >
        <div className={_classes.orderDetailSection}>
          {orderDetailDescription}
          {isAuditable && (
            <Alert
              severity='error'
              variant='filled'
              icon={<BagOutlineIcon fill='inherit' />}
              className={_classes.auditBanner}
            >
              <div dangerouslySetInnerHTML={{ __html: lang.auditable }} />
            </Alert>
          )}
          {hasOrderManagement && (
            <OrderDetailDisclaimer order={orderManagement} isInProductSection />
          )}
        </div>
        <OrderProductsByCorridor
          classes={{ root: _classes.root, corridor: _classes.corridorName }}
          orderId={orderId}
        />
        {whims.map((whim, index) => (
          <OrderDetailWhim
            key={`whim-${whim.id}-${index}`}
            id={whim.id}
            name={whim.name}
            price={whim.price}
            showDeleteBtn={isBeingManaged}
          />
        ))}
      </div>

      <ForceOrderInvoicePrinting orderIdForced={orderId} />
    </div>
  );
}

export default OrderDetailDialogProductsSection;
